// extracted by css-extract-rspack-plugin
var _1 = "details-ti4dqT";
var _2 = "edit-form-hOnwwI";
var _3 = "edit-form-hOnwwI";
export { _1 as "details", _2 as "edit-form", _3 as "editForm" }
